import { DSActions } from '../../../cimsPage/instances/ds'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const actions = CreateViewEditSoftRemoveRestore({
  object: 'Action',
  page: DSActions,
  create: 'd7db120b-7c5a-4273-9bf4-848d3ea0ce09',
  view: '0e9b429c-1867-4ffa-86cd-b77e676aac84',
  edit: '2a853e60-855a-4331-9186-cb0443a415e3',
  removeRestore: 'cf219f4d-9690-4cd5-854f-2893fc1e8e37',
})

export const CreateDesignSubmittalAction = actions.Create
export const ViewDesignSubmittalAction = actions.View
export const EditDesignSubmittalAction = actions.Edit
export const RemoveRestoreDesignSubmittalAction = actions.RemoveRestore

export type DSActionPermission =
  | typeof CreateDesignSubmittalAction
  | typeof ViewDesignSubmittalAction
  | typeof EditDesignSubmittalAction
  | typeof RemoveRestoreDesignSubmittalAction
